// 表单数据
export const formData = {
  areaName: '',
  pareaId: '',
  pinyin: '',
  isHot: true,
  isArea: true,
  // lng: '0',
  // lat: '0',
  // areaCode: ''
  level: 0,
};

// 表单验证规则
export const formRules = {
  areaName: [{ required: true, message: '城市名称不能为空', trigger: 'blur' }],
  pareaId: [{ required: true, message: '请选择城市归属省份', trigger: 'blur' }],
  pinyin: [{ required: true, message: '拼音不能为空', trigger: 'blur' }],
  // isHot: [{ required: true, message: "请选择是否热门", trigger: "blur" }],
  // isArea: [{ required: true, message: "请选择是否城市", trigger: "blur" }]
  // areaCode: [{ required: true, message: "编码不能为空", trigger: "blur" }],
  // lng: [{ required: true, message: "经度不能为空", trigger: "blur" }],
  // lat: [{ required: true, message: " 纬度不能为空", trigger: "blur" }],
};
